import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'
import { path } from 'ramda'

const queryTransform = {
  motorista: query.ilike('motorista'),
  cpf: query.like('cpf'),
  placa: query.ilike('placa'),
  mercadoria: query.ilike('mercadoria'),
  nomeEmbarcador: query.ilike('nomeEmbarcador'),
  status: query.eq('status'),
  responsavelId: query.eq('responsavelId'),
  createdAt: query.gte('createdAt'),
  dataTermino: query.gte('dataTermino'),
  createdAtFim: query.lte('createdAtFim'),
  dataTerminoFim: query.lte('dataTerminoFim'),
  ...paginate
}

const solicitacoesRepository = createRepository({
  path: 'solicitacoes',
  restApi,
  queryTransform,
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

solicitacoesRepository.historicoDaSolicitacao = where => {
  return restApi.get('solicitacoes/historico', { ...where })
}

solicitacoesRepository.count = where => {
  return restApi.get('solicitacoes/count', { where })
}

solicitacoesRepository.countPure = where => {
  return restApi.get('solicitacoes/count-pure', { where })
}

solicitacoesRepository.countPureAnalista = where => {
  return restApi.get('solicitacoes/count-pure-analista', { where })
}

solicitacoesRepository.countAnalista = responsavelId => {
  return restApi.get('solicitacoes/count', {
    where: { and: [{ status: 'ANALISE' }, responsavelId] }
  })
}

solicitacoesRepository.proxima = () => {
  return restApi.get('solicitacoes/proxima')
}

solicitacoesRepository.fonteLiberacaoHistorico = where => {
  return restApi.get('solicitacoes/fonte-liberacao/historico', { where })
}

solicitacoesRepository.pendenteGestor = (id, data) => {
  return restApi.post(`solicitacoes/${id}/pendenteGestor/`, data)
}

solicitacoesRepository.pendente = (id, data) => {
  return restApi.post(`solicitacoes/${id}/pendente/`, data)
}

solicitacoesRepository.liberar = (id, data) => {
  return restApi.post(`solicitacoes/${id}/liberar/`, data)
}

solicitacoesRepository.liberarComPendencia = (id, data) => {
  return restApi.post(`solicitacoes/${id}/liberarComPendencia/`, data)
}

solicitacoesRepository.delegarAssistente = (id, data) => {
  return restApi.post(`solicitacoes/${id}/delegarAssistente/`, data)
}

solicitacoesRepository.cancelar = id => {
  return restApi.post(`solicitacoes/${id}/cancelar/`)
}

solicitacoesRepository.naoRecomendar = (id, data) => {
  return restApi.post(`/solicitacoes/${id}/naoRecomendarJWT`, data)
}

solicitacoesRepository.reanalise = id => {
  return restApi.post(`/solicitacoes/${id}/reanalise`)
}

solicitacoesRepository.validaDocumento = (id, data) => {
  return restApi.patch(`/solicitacoes/${id}/validarDocumento`, data)
}

solicitacoesRepository.liberarGestor = (id, data) => {
  const formData = new FormData()
  formData.append('anexoLiberadaGestor', data.anexoLiberadaGestor)
  formData.append(
    'data',
    JSON.stringify({
      observacaoLiberadaGestor: data.observacaoLiberadaGestor,
      novoLimiteCarga: data.novoLimiteCarga,
      dataBloqueio: data.dataBloqueio,
      monitorar: data.monitorar,
      cenarioId: data.cenarioId,
      validate: data.validate
    })
  )
  return restApi.post(`/solicitacoes/${id}/liberarGestorJWT/`, formData, {
    header: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

solicitacoesRepository.removerDataTermino = id => {
  return restApi.post(`/solicitacoes/${id}/removerDataTermino/`)
}

solicitacoesRepository.getClassificacao = id => {
  return restApi.get(`/solicitacoes/${id}/classificacao`)
}

solicitacoesRepository.countPureExclusivaAnalista2 = where => {
  return restApi.get('solicitacoes/count-pure-exclusiva-analista2', { where })
}

export default solicitacoesRepository
